export default "__VITE_ASSET__298c6bce__"